
import {Component, Prop, Vue} from 'vue-property-decorator';
import {SocialPlatformData} from "@/services/homeSpace/HomeService";

@Component({})

export default class SocialNetwork extends Vue {
  @Prop({type: Array, required: false, default: []})
  readonly pubs!: Array<SocialPlatformData>;

  @Prop({type: Array, required: false, default: []})
  readonly socialNetworks!: Array<SocialPlatformData>;

}
